module.exports = __webpack_public_path__ + "static/media/questionnaire-icon.b68535ff.svg";